<template>
  <div>
    <div class="">
      <Tabs>
        <TabPane label="入住率"></TabPane>
      </Tabs>
    </div>
    <div class="main flex">
      <section class="flexauto charts-wrapper">
        <div id="linecharts" :style="{width:chartsWidth+'px',height:chartHeight+'px'}">
        </div>
      </section>
      <section class="rank flexnone">
        <h3>入住率排名</h3>
        <ul style="margin-top: 16px">
          <li v-for="(item,index) in projectInfos" :key="'keyB'+index">
            <span>
              <span :class="[0,1,2].indexOf(index)===-1?'indexothers':'index012'"> {{index+1}}</span>
              <span>{{item.name}}</span>
            </span>
            <span>{{(item.value*100).toFixed(2)+'%'}}</span>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/line')
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/dataZoom");
  require("echarts/lib/component/legend");
  require('echarts/theme/macarons');


  export default {
    name: "CheckInRatio",
    props: {
      // n:{
      //   type:Number,
      //   default:0
      // },
      projectInfos: {
        type: Array,
        default: () => {
          return []
        }
      },
      checkinList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    watch: {
      checkinList: {
        deep: true,
        handler: function () {
          this.$nextTick(()=>{
            this.setE()

          })

        }
      }
    },
    computed: {
      xAxisData() {
        const ret = []
        if (this.checkinList.length > 0) {
          this.checkinList[0].info.forEach(ele => {
            ret.push(ele.dateTime)
          })
        }
        return ret
      },
      seriesData() {
        const ret = []
        this.checkinList.forEach(ele => {
          const data = []
          ele.info.forEach(ele1 => {
            data.push(ele1.checkinRate.value)
          })

          ret.push({
            name: ele.projectName,
            type: 'line',
            // stack: '总量',
            data: data
          })
        })
        return ret
      }

    },
    data() {
      return {
        chartsWidth: 0,
        chartHeight: 0,
      }
    },
    methods: {
      setWH() {
        const h = document.getElementsByClassName('charts-wrapper')[0]
        this.chartHeight = Number(window.getComputedStyle(h).height.slice(0, -2))
        this.chartsWidth = Number(window.getComputedStyle(h).width.slice(0, -2))
      },
      setE() {

        const lineChart = echarts.init(document.getElementById('linecharts'),'macarons');
        const seriesData = []
        this.checkinList.forEach(ele => {
          const data = []
          ele.info.forEach(ele1 => {
            data.push(ele1.checkinRate.value)
          })

          seriesData.push({
            name: ele.projectName,
            type: 'line',
            // stack: '总量',
            data: data
          })
        })



          const xAxisData = []
          if (this.checkinList.length > 0) {
            this.checkinList[0].info.forEach(ele => {
              xAxisData.push(ele.dateTime)
            })
          }
        const option = {
          legend: {
            bottom: 10

          },
          dataZoom: [
            {
              type: 'inside',
              // realtime: true,
              // start: 65,
              // end: 85
            }
          ],
          tooltip: {
            trigger: 'axis',
            // formatter:'{a}:{c}',

            formatter: function (params) {
              params.sort((p1,p2)=>{
                return p2.value-p1.value
              })
              let ret=params[0].name+'<br>'
              params.forEach(ele => {
                ret += '<p style="vertical-align: top;line-height: 1;margin-bottom: 6px">' +'<span style="vertical-align:top;display: inline-block;width: 14px;height: 14px;border-radius:7px;background-color:' +ele.color+' "> </span>'
                  +'<span style="vertical-align: top">'+ ele.seriesName + ':' + (ele.value * 100).toFixed(2) + '%' + '\n'  +'</span></p>'
              })
              return ret

            }
          },
          grid: {
            top:20,
            left: 80,
            bottom:100
            // top:'5%'
          },
          xAxis: {
            type: 'category',
            data: xAxisData  //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value',
            min:'dataMin',
            axisLabel: {
              formatter: function (value) {
                return Number(value * 100).toFixed(2) + '%'

              }
            }
          },
          series: seriesData

        }
        lineChart.clear()
        lineChart.setOption(option)
      }

    },
    mounted() {
      this.setWH()
      // this.$nextTick(()=>{
      //   this.setE()
      // })
    }
  }
</script>
<style scoped>
  .circle{

  }

  ul li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    /*background-color: #A4A7AF;*/
  }

  .charts-wrapper {
    /*background-color: lightgray;*/
  }

  #linecharts {
    /*background-color: #F9F9F9;*/
  }

  .main {
    /*background-color: #F9F9F9;*/
    height: 350px;
  }

  .flexauto {
    flex: auto;
  }

  .flexnone {
    flex: none;
  }

  .flex {
    display: flex;
  }

  .rank {
    height: 100%;
    overflow: auto;
    width: 300px;
    /*background-color: lightsalmon;*/
    padding: 0 30px;
  }

  .index012, .indexothers {
    display: inline-block;
    margin-right: 15px;

    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 9px;

  }

  .index012 {
    background-color: #444444;
    color: white;

  }

  .indexothers {
    background-color: #F9F9F9;
    color: black;

  }

</style>
